<template>
  <v-container v-resize="checkMobile" data-testid="doc-template-page">
    <plan-gate service="pdf_docs_generation" />
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card :class="$vuetify.theme.dark ? 'dark' : ''">
      <v-toolbar v-if="!isMobile" text :color="$vuetify.theme.dark ? '' : 'white'" class="">
        <v-btn small text class="ml-2 mt-2" @click="goBack">{{
                  $t("custom.goback")
                  }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="newTemplate()" v-if="!showNewtemplate">+ {{ $t("templates.new") }}</v-btn>
        <v-btn small color="primary" @click="showNewtemplate = false" v-else>- {{ $t("templates.select") }}</v-btn>
        <v-btn icon :href="docsLink('/dokumenty/shablony')" target="_blank" class="ml-2">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap class="mt-1">
            <v-flex md12 class="mb-2" v-if="showNewtemplate">
              <v-select v-model="template_type" item-text="name" item-value="value" :items="template_types"
                @change="tiptap_key += 1" hide-details :label="$t('templates.select_type')"></v-select>
              <v-text-field v-model="name" type="text" :label="$t('templates.name')"></v-text-field>
              <v-autocomplete v-model="car_id" item-text="code" item-value="id" :loading="isLoadingCars"
                :search-input.sync="searchCar" auto-select-first text hide-no-data hide-details
                :label="$t('templates.to_car')" :items="cars">
              </v-autocomplete>
            </v-flex>
            <v-flex md12 v-if="showNewtemplate" class="text-center mb-2">
              <v-btn small class="mr-1 mt-2" color="success" @click="saveContent()">{{ $t("custom.save") }}</v-btn>
            </v-flex>
            <v-flex md12 class="mb-2" v-if="!showNewtemplate">
              <v-autocomplete v-model="template" item-text="name" item-value="id" :items="templates"
                @change="tiptap_key += 1" hide-details :label="$t('templates.select_2')"></v-autocomplete>
              <v-text-field v-model="name" type="text" :label="$t('templates.name')"></v-text-field>
              <v-autocomplete v-model="car_id" item-text="code" item-value="id" :loading="isLoadingCars"
                :search-input.sync="searchCar" auto-select-first text hide-no-data hide-details
                :label="$t('templates.to_car')" :items="cars">
              </v-autocomplete>
              <v-flex md12 class="text-center">
                <v-btn small v-if="template != null && content" class="mr-1 mt-2" color="success"
                  @click="updateContent()">{{ $t("custom.save") }}</v-btn>
                <v-btn small v-if="template" color="error" class="mt-2" @click="deleteTemplate()">{{ $t("custom.delete")
                                  }}</v-btn>
              </v-flex>
            </v-flex>
            <v-flex :key="tiptap_key" md12 v-if="!showCustomHtml" style="width: 210mm; margin: 0 auto">
              <p class="text-center" v-html="$t('templates.word_warn_html', { url: docsLink('/dokumenty/shablony') })"></p>
              <TiptapEditor v-if="content !== null" v-model="content"></TiptapEditor>
            </v-flex>
            <v-flex md12 class="mt-2 text-center" v-if="template == null && content && !showCustomHtml">
              <v-btn color="success" @click="saveContent()">{{
                              $t("custom.save")
                              }}</v-btn>
            </v-flex>
            <v-flex md12 class="mt-2 text-center" v-if="template != null && content && !showCustomHtml">
              <v-btn color="success" @click="updateContent()">{{
                              $t("custom.save")
                              }}</v-btn>
            </v-flex>
            <!-- <v-flex md12>
              <v-switch
                v-model="showCustomHtml"
                class="mt-0 mr-1 mr-1"
                label="HTML"
                dense
                hide-details
              ></v-switch>
              <v-textarea
                v-if="showCustomHtml"
                v-model="content"
                auto-grow
                filled
                label="HTML"
              ></v-textarea>
            </v-flex> -->
            <v-flex md12 class="mt-2 text-center" v-if="template == null && content && showCustomHtml">
              <v-btn color="success" @click="saveContent()">{{
                              $t("custom.save")
                              }}</v-btn>
            </v-flex>
            <v-flex md12 class="mt-2 text-center" v-if="template != null && content && showCustomHtml">
              <v-btn color="success" @click="updateContent()">{{
                              $t("custom.save")
                              }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import moment from "moment";
import TiptapEditor from "@/components/common/TiptapEditor.vue";
export default {
  data() {
    return {
      content: null,
      template_type: "booking_start",
      template_types: [
        { name: this.$t("sign.start_booking"), value: "booking_start" },
        { name: this.$t("sign.end_booking"), value: "booking_end" },
        { name: this.$t("sign.prolong"), value: "prolong" },
        { name: this.$t("templates.invoices"), value: "invoice" },
        { name: this.$t("templates.act"), value: "act" },
      ],
      templates: [],
      template: null,
      name: null,
      tiptap_key: 1,
      cars: [{ code: this.$t("templates.no_car"), id: null }],
      car_id: null,
      showNewtemplate: false,
      showCustomHtml: false,
      isLoadingCars: false,
      searchCar: null,
      isMobile: false,
      isLoading: false,
      isLoadingSubscribeToPaidTariff: false,
    };
  },
  mounted() {
    let self = this;
  },
  created() {
    let self = this;
    if (this.$store.getters.isLoggedIn) {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/templates`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.templates = response.data;
          if (this.templates.length > 0) {
            this.content = this.templates[0].content;
            this.name = this.templates[0].name;
            this.car_id = this.templates[0].car_id;
            this.template = this.templates[0].id;
          }
          this.axios
            .get("/api/v1/active_cars", {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              response.data.data.forEach((element) => {
                this.cars.push(element.attributes);
              });
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.cars_load"));
              console.log(error);
            });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.templates"));
        })
        .finally((this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
      this.$router.push({ path: `/signin` }).catch((err) => { });
    }
  },
  watch: {
    template() {
      if (this.template) {
        let finded = this.templates.find((tmpl) => {
          return tmpl.id == this.template;
        });
        if (finded) {
          this.content = finded.content;
          this.$forceUpdate();
          this.name = finded.name;
          this.car_id = finded.car_id;
        }
      }
    },
    searchCar(val) {
      // Items have already been loaded
      if (this.cars.length > 1) return;

      // Items have already been requested
      if (this.isLoadingCars) return;

      this.isLoadingCars = true;

      // Lazily load input items
      this.axios
        .get("/api/v1/active_cars", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.cars.push(element.attributes);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.cars_load"));
          console.log(error);
        })
        .finally(() => (this.isLoadingCars = false));
    },
  },
  computed: {
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if(this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if(this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else {
              return moment(this.$store.getters.getMainCompany.created_at).isBefore(moment().subtract(7, "day")) ? true : false;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
  },
  methods: {
    saveContent() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (
        this.name &&
        this.name.length > 3 &&
        this.isStaff
      ) {
        let self = this;
        this.isLoading = true;
        this.axios
          .post(
            "/api/v1/templates",
            {
              templates: {
                name: this.name,
                content: this.content,
                template_type: this.template_type,
                car_id: this.car_id && this.car_id != 0 ? this.car_id : null,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.templates.push(response.data);
            this.showNewtemplate = false;
            this.$notify(this.$t("templates.created"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.template_save"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.template_save"), this.$t("templates.name_to_short"), "error", 3000);
      }
    },
    updateContent() {
      if (
        this.name &&
        this.name.length > 3 &&
        this.isStaff
      ) {
        let self = this;
        this.isLoading = true;
        this.axios
          .patch(
            `/api/v1/templates/${this.template}`,
            {
              templates: {
                name: this.name,
                content: this.content,
                template_type: this.template_type,
                car_id: this.car_id,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.templates.findIndex(
              (element) => element.id === response.data.id
            );
            this.templates.splice(foundIndex, 1, response.data);
            this.$notify(this.$t("templates.updated"), "", "success");
          })
          .catch((error) => {
            self.setError(error, self.$t("errors.template_update"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.template_save"), this.$t("templates.name_to_short"), "error");
      }
    },
    newTemplate() {
      this.template = null;
      this.showNewtemplate = true;
      this.content = this.$t("templates.initial");
    },
    deleteTemplate() {
      let id = this.template;
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            let self = this;
            this.isLoading = true;
            this.axios
              .delete(`/api/v1/templates/${id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then((response) => {
                this.templates.splice(
                  this.templates.findIndex((template) => {
                    return template.id == id;
                  }),
                  1
                );
                if (this.templates.length > 0) {
                  this.content = this.templates[0].content;
                  this.template = this.templates[0].id;
                }
              })
              .catch((error) =>
                this.setError(error, this.$t("errors.template_delete"))
              )
              .finally(() => (this.isLoading = false));
            this.$notify(this.$t("custom.deleted"), this.$t("templates.deleted"), "success");
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
  },
  components: {
    TiptapEditor,
  },
};
</script>
<style>
/* TiptapEditor стили наследуются из компонента */
</style>
